<div class="row">
    <div class="col-md-12">
        <ax-panel title="Históricos">
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #grid 
                    [dataSource]="registros"

                    [enableVirtualization]='true'  height='400' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 
                 
                    [toolbar]='toolbarItens'

                    [selectionSettings]="{ enableToggle: false }"

                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'

                    (recordDoubleClick)="abrirConsulta()"

                    (toolbarClick)='toobarClick($event);'
                    >
                    <e-columns>
                        <e-column field='id' width='50' [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                        <e-column field='data' [headerText]="'Data'" [type]="'date'" [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='historico' [headerText]="'Histórico'" [visible]="true"></e-column>
                        <e-column field='profissionalNome' [headerText]="'Profissional'"></e-column>
                        <e-column field='profissionalConselho' [headerText]="'Profissional Conselho'"></e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
</div>

<app-historia-clinica-cadastro [apenasConsulta]="true" #modalHistoria></app-historia-clinica-cadastro>

